import Airtable from "airtable";

Airtable.configure({
  endpointUrl: "https://api.airtable.com",
  // todo - get this from env
  apiKey: "keylI9jMtmlbxZj1C",
});

export const airtableClient = Airtable;
